import React, { useContext } from "react";
import { getAppConfig } from "@config/appConfig";
import { PLACEHOLDER_MOVIE_POSTER } from "@config/ImageSizes";
import { AuthContext } from "@context/AuthContext";
import Loader from "@components/Ui/Loader";
import MovieSlider from "@components/V3/MoviesSlider";
import { getImageAtSize } from "@utils/imageUtils.js";

const ComingSoon = () => {
    const { comingSoon, isMoviesLoading } = useContext(AuthContext);
    const config = getAppConfig();
    const fallbackImage = `${config?.cdnUrl}${PLACEHOLDER_MOVIE_POSTER}`;

    if (isMoviesLoading) {
        return <Loader isLoading={true} text="Fetching Movies" />;
    }

    if (!comingSoon || !Array.isArray(comingSoon) || comingSoon.length === 0) {
        return (
            <div className="movie-slider">
                <p className="paragraph">There are no upcoming movies.</p>
            </div>
        );
    }

    return (
        <MovieSlider
            title="Coming Soon"
            movies={comingSoon}
            isLoading={isMoviesLoading}
            fallbackImage={fallbackImage}
            baseClass="movie-slider"
            getMovieId={(m) => m.id}
            getMovieTitle={(m) => m.title}
            getMovieImage={(m) => getImageAtSize(m.movie_image?.[0]?.local_url, 428)}
        />
    );
};

export default ComingSoon;
